export function bpmpi_config() {
  return {
    onReady: function () {
      // Evento indicando quando a inicialização do script terminou.
      document.getElementById("btnSendOrder").disabled = false;
      if (typeof window._on3dsReady === 'function') window._on3dsReady();
    },
    onSuccess: function (e) {
      // Cartão elegível para autenticação, e portador autenticou com sucesso.
      const result = {
        status: 'success',
        cavv: e.Cavv,
        xid: e.Xid,
        eci: e.Eci,
        version: e.Version,
        referenceId: e.ReferenceId,
      };
      window._3dsResponse = result;
      console.log('Success: '+ e.ReferenceId);
      if (typeof window._resolve3ds === 'function') window._resolve3ds(result);
    },
    onFailure: function (e) {
      // Cartão elegível para autenticação, porém o portador finalizou com falha.
      const result = {
        status: 'failure',
        xid: e.Xid,
        eci: e.Eci,
        version: e.Version,
        referenceId: e.ReferenceId,
      };

      window._3dsResponse = result;
      console.log('Failed: '+ e.ReferenceId);
      if (typeof window._resolve3ds === 'function') window._resolve3ds(result);
    },
    onUnenrolled: function (e) {
      // Cartão não elegível para autenticação (não autenticável).
      const result = {
        status: 'unenrolled',
        Xid: e.Xid,
        Eci: e.Eci,
        Version: e.Version,
        ReferenceId: e.ReferenceId,
        bpmpi_ordernumber: null,
      };
      window._3dsResponse = result;

      console.log('onUnenrolled: '+ e.ReferenceId);
      if (typeof window._resolve3ds === 'function') window._resolve3ds(result);
    },
    onDisabled: function () {
      // Loja não requer autenticação do portador (classe "bpmpi_auth" false -> autenticação desabilitada).
    },
    onError: function (e) {
      // Erro no processo de autenticação.
      const result = {
        status: 'error',
        xid: e.Xid,
        eci: e.Eci,
        version: e.Version,
        referenceId: e.ReferenceId,
        returnCode: e.ReturnCode,
        returnMessage: e.ReturnMessage,
      };

      window._3dsResponse = result;
      console.log('Error: '+ e.ReferenceId);
      if (typeof window._resolve3ds === 'function') window._resolve3ds(result);
    },
    onUnsupportedBrand: function (e) {
      // Bandeira não suportada para autenticação.
      const result = {
        status: 'unsupportedBrand',
        returnCode: e.ReturnCode,
        returnMessage: e.ReturnMessage,
      };

      window._3dsResponse = result;
      console.log('UnsupportedBrand: '+ e.ReturnCode);
      if (typeof window._resolve3ds === 'function') window._resolve3ds(result);
    },
    Environment: "PRD", // Produção: "PRD"
    Debug: false,
    } 
}
window.bpmpi_config = bpmpi_config;


export function wait3dsResponse() {
  return new Promise((resolve, reject) => {
    window._resolve3ds = resolve;
    window._reject3ds = reject;
  });
}

export function init3dsData({ accessToken, orderNumber, currency, amount, paymentMethod, cardNumber, expMonth, expYear, card_holdername, customer, installments }) {
  const createInput = (className, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.className = className;
    input.id = className;
    input.value = value;
    document.body.appendChild(input);
  };

  createInput('bpmpi_auth', 'true');
  createInput('bpmpi_accesstoken', accessToken);
  createInput('bpmpi_ordernumber', orderNumber);
  createInput('bpmpi_currency', currency);
  createInput('bpmpi_totalamount', amount);
  createInput('bpmpi_paymentmethod', paymentMethod);
  createInput('bpmpi_auth_notifyonly', 'true')
  createInput('bpmpi_cardnumber', cardNumber);
  createInput('bpmpi_cardexpirationmonth', expMonth);
  createInput('bpmpi_cardexpirationyear', expYear);
  createInput('bpmpi_shipto_sameasbillto', 'true');
  createInput('bpmpi_cardalias', card_holdername);
  createInput('bpmpi_billto_customerid', customer.document.replace(/^(\+)|\D/g, ''));
  createInput('bpmpi_merchant_newcustomer', 'credit');
  createInput('bpmpi_billto_phonenumber', customer.phone_number ?? '5511999999999');
  createInput('bpmpi_billto_email', customer.email);
  createInput('bpmpi_billto_street1', customer.street_name ?? 'Av Marechal Camara 160');
  createInput('bpmpi_billto_street2', customer.street_name ?? 'Sala 934 Centro');
  createInput('bpmpi_billto_city', customer.city ?? 'Rio de Janeiro');
  createInput('bpmpi_billto_state', customer.state ?? 'RJ');
  createInput('bpmpi_billto_country', 'BR');
  createInput('bpmpi_billto_zipcode', customer.zip_code ?? '20020080');
  createInput('bpmpi_installments', installments); 
}